export const VERSION_NUMBER = '1.000';
export const BUILD_TIME = '2021-20-05T14:29:04.545Z';
export const BUILD_NOTES = `
<ul>
    <li>Initial launch of site.</li>
</ul>`;
